export const nodeWidth = 240
export const nodeHeight = 330
